import { linkedSetEvent } from "@/api/global.js"
import { apiGetreportdatalist } from '@/port/clientSide/formFillinPageChild/newRelRadio'
import { apiGetapprovalreport } from '@/port/admins/report'
import { sourceNewRel } from './relevancy'
import { apiGetapprovaldashboardpreview } from '@/port/admins/instrument'

export const getNewRelRadioRes = async (relConfig, approvalId, formdata, AuditList) => {
    let param = null;
    let par = null;
    param = onCondition(relConfig, formdata);
    if (param && param.relWidDataLook) {
        par = {
          relWidDataLook: param.relWidDataLook,
          approvalId: relConfig.relFormId,
          datahided: relConfig.datahided,
          appid: approvalId,
          curpage:  1,
          pagesize: 1,
          type: 0,
          cateId: -1
        }
        if (param.dataconfig) par.dataconfig = JSON.stringify(param.dataconfig);
        if (param.condition) {
          // 谭说如果condition是空对象，则不走联动接口 25.4.11
          if (JSON.stringify(param.condition) === '{}') return
          par.condition = JSON.stringify(param.condition)
        }
        // if (e) par.key = this.value;
    } else {
        par = {
          relWidDataLook: relConfig.relWidDataLook ? relConfig.relWidDataLook : 1,
          approvalId: relConfig.relFormId,
          curpage: 1,
          pagesize: 1,
          datahided: relConfig.datahided,
          appid: approvalId,
          query: "{}",
          key: '',
          // key: this.value,
        };
    }
    if (relConfig.selectTable && relConfig.selectTable === 'customization' && relConfig.isSource && relConfig.isSource === 2) {
        console.log('这里是工坊的搜索', relConfig)
        const re = await apiGetapprovalreport({ approvalReportId: relConfig.relFormId }).catch(err => { console.log(err) })
        let list = []
        if (re.code === 0) {
          const source = JSON.parse(re.data.config)
          const sourceInd = source.findIndex(it => it.type === 'output')
          list = source[sourceInd].datas || []
        }
        // 拼接工坊值
        const config = sourceNewRel(relConfig, [], 'titleId', list, formdata, AuditList)
        console.log('工坊拼接数据', config)
        const res = await apiGetapprovaldashboardpreview({ curpage: 1, pagesize: 1, config: config, nodeId: config[config.length- 1].id }).catch (err => { console.log(err) })
        console.log('工坊查询结果', res)
        if (res.code === 0) {
            const listObj = {}
            for (const s of (relConfig.list || [])) {
                const sName = s.titleId.split('.')
                listObj[sName[0]] = tObj(sName.slice(1), listObj[sName[0]] ? listObj[sName[0]] : {}, s.titleId)
                if (sName[0] !== s.name) listObj[s.titleId] = s.name
            }
            // 工坊查询出来的手动给一个 approvingId 用作数据对比
            res.data = res.data.map(its => {
              its.approvingId = approvalId
              its = sObj(its, listObj)
              return its
            })
            const ob = {}
            const rr = res.data.length > 0 ? res.data[0] : {}
            if (relConfig.list && relConfig.list.length > 0) ob[relConfig.title + '_' + relConfig.type] = rr[relConfig.list[0].titleId]
            for (const i of relConfig.list || []) {
                if (i.titleId) {
                    ob[i.title + '_' + i.type] = rr[i.titleId]
                }
            }
            return ob
        }
    } else if ((!relConfig.selectTable || relConfig.selectTable === 'customization') && (!relConfig.isSource || relConfig.isSource === 1)) {
        const res = await apiGetreportdatalist(par).catch(error => {
          console.log(error);
        })
        if (res.code === 0) {
            const ob = {}
            const rr = res.data.length > 0 ? res.data[0] : {}
            ob[relConfig.title + '_' + relConfig.type] = rr['自定义标题']
            for (const i of relConfig.list || []) {
                if (i.titleId) {
                    ob[i.title + '_' + i.type] = rr[i.titleId]
                }
            }
            return ob
        }
    }
    return {}
}


// 做返回结构
function tObj (arr, obj, value) {
    if (!arr || arr.length === 0) return value
    const key = arr[0]
    obj[key] = arr.length > 1 ? tObj(arr.slice(1), {}, value) : value
    return obj
}
// 扁平化数据
function sObj (val, config) {
    for (const i in val) {
      if (typeof val[i] === 'object' && typeof config[i] === 'object') {
        val = {
          ...sObj(val[i], config[i]),
          ...val
        }
      } else {
        val[config[i]] = val[i]
      }
    }
    return val
}

function onCondition(item, formdata) {
    if (item.dataconfig && item.dataconfig.setUpValue == 1 || item.type === 'new-rel-radio' && item.dataconfig && item.dataconfig.setUpValue == 7) {
      //如果有配置联动
      let param = false;
      if (item.dataconfig.linked && item.dataconfig.linked.conditional) {
        param = linkedSetEvent(item.dataconfig, formdata, {
          index: item.thisIndex
        });
        if (param) {
          delete param.dataconfig;
        }
      }
      item.condition = param ? param : {}; //有配置联动，数据没填完使用
    }
    return { ...item };
}